export default "__VITE_ASSET__BxRvQcep__"